import React from 'react'
import { Accordion, ErrorBoundary } from '@sainsburys-tech/bolt'
import CMSComponents, { components, GetComponent } from '@sainsburys-tech/bolt-cms-components'
import { connect } from 'react-redux'
import * as Styled from './MeasureBeforeYouOrder.styles'
import { scrollToAccordion } from '../../../helpers/openAccordion'
import { pushEventAndTrack } from '../../../helpers/taggingSerializer'

const MeasureBeforeYouOrderAccordion = ({ content }) => {
  const Header = <Styled.Heading>Measure before you order</Styled.Heading>
  const dataTest = 'measure-before-you-order-accordion'
  const onAccordionInteraction = (index, show) => {
    if (show) {
      scrollToAccordion('#measure-before-you-order-accordion', true)
    }

    // Adobe Analytics Tracking Code
    const adobeAnalytics = show ? pushEventAndTrack : () => {}
    adobeAnalytics({
      eventInfo: {
        eventName: 'pdp_showMore',
        eventAction: 'Measure before you order'
      }
    })
  }

  const accordionOptions = {
    title: Header,
    name: 'measure-before-you-order-accordion',
    id: 'measure-before-you-order-accordion',
    'data-test': dataTest,
    index: 'measure-before-you-order-accordion',
    onClick: onAccordionInteraction
  }

  return (
    content && (
      <Accordion.Item as='h3' hasBorderBottom noAnimation {...accordionOptions}>
        <CMSComponents components={components}>
          <ErrorBoundary>
            {content.map((item, index) => {
              return <GetComponent {...item} key={`cms-measure-accordion-${index}`} />
            })}
          </ErrorBoundary>
        </CMSComponents>
      </Accordion.Item>
    )
  )
}

const mapStateToProps = state => {
  const { cms } = state

  const props = {
    content: cms.mto.measure
  }

  return props
}

export default connect(mapStateToProps)(MeasureBeforeYouOrderAccordion)
export { MeasureBeforeYouOrderAccordion }
